/** Describes a burnable annotation. */
export abstract class BurnableAnnotation {
  /** Whether the annotation should be burned into the document.
   *
   * Burnable annotations are drawn to the rendered PDF document when the
   * `burn` property is set to `true` and the `PdfViewerComponent` is initialized
   * or `PdfViewerComponent.burnAnnotations()` is called.
   *
   * @example
   * ```typescript
   * // Mark the annotation to be burned.
   * selectedAnnotation.burn = true;
   * // Get the PdfViewerComponent instance, and call burnAnnotations.
   * this.pdfViewer = this.ui.state().pdfViewer;
   * this.pdfViewer.burnAnnotations();
   * ```
   */
  burn: boolean = false;
}
